import { render, staticRenderFns } from "./PCHeaderNav.vue?vue&type=template&id=56db846f&scoped=true"
import script from "./PCHeaderNav.vue?vue&type=script&lang=js"
export * from "./PCHeaderNav.vue?vue&type=script&lang=js"
import style0 from "./PCHeaderNav.vue?vue&type=style&index=0&id=56db846f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db846f",
  null
  
)

export default component.exports